import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useGoBack } from '@/hooks/use-go-back'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { NewsForm } from '@/features/news/components/news-form'
import { useNewsQuery } from '@/features/news/api/news.query'
import { useRequireAdmin } from '@/features/auth'
import { Spinner } from '@/components/ui/spinner'

export const Route = createFileRoute('/_authenticated/news/$newsId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { newsId } = Route.useParams()
  const navigate = useNavigate()
  const goBack = useGoBack()
  const { canAccess, isLoading: isAuthLoading } = useRequireAdmin('/news/$newsId', { newsId })
  const { data: news, isLoading } = useNewsQuery(newsId)

  if (isAuthLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner className="size-8" />
      </div>
    )
  }
  if (!canAccess) return null

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4 p-4">
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/news/$newsId', params: { newsId } })}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h1 className="text-xl font-semibold">Modifica News</h1>
        </div>
        <div className="flex h-64 items-center justify-center rounded-lg border">
          <p className="text-muted-foreground">Caricamento...</p>
        </div>
      </div>
    )
  }

  if (!news) {
    return (
      <div className="flex flex-col gap-4 p-4">
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/news' })}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h1 className="text-xl font-semibold">Modifica News</h1>
        </div>
        <div className="flex h-64 items-center justify-center rounded-lg border">
          <p className="text-muted-foreground">News non trovata</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/news/$newsId', params: { newsId } })}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-xl font-semibold">Modifica News</h1>
      </div>
      <NewsForm news={news} onSuccess={() => navigate({ to: '/news/$newsId', params: { newsId } })} />
    </div>
  )
}
